import { Route, Routes, BrowserRouter } from "react-router-dom";
import { useState,useEffect, useContext } from 'react';

import Meetings from './components/meetings';
import Meeting from './components/meeting';
import Event from './components/event';
import Events from './components/events';
import Frame from './components/frame';
import Error from './components/error';
import Test from './components/test';
import Hub from './components/hub';
import { useCurrentUser } from "./hooks/useCurrentUser"
import {AppState, AppContext} from './context/AppProvider'

// import '@passageidentity/passage-elements/passage-register';
import './components/components.css';
import './App.css';
import axios from "axios"

const mongoose = require('mongoose')

let meetings = require('./seeders/seedMeetings.json');
let events = require('./seeders/seedEvents.json');
let votes = require('./seeders/seedVotes.json');

const username = ""
// localStorage.setItem('cur_user',JSON.stringify(username))
// const vote = window.localStorage.getItem('vote')
// const meeting = JSON.parse(localStorage.getItem('meeting'))

const getData = async () => {
  const res = await axios.get('https://geolocation-db.com/json/')
  localStorage.setItem('geo_dat',JSON.stringify(res.data))
  // console.log('localstorage geo_dat: ',JSON.parse(localStorage.getItem('geo_dat')))
}

function App() {
  const [fView , setFView] = useState()
   const {
        isLoggedIn,
        view, 
        setView,
        room,
        setRoom,
        user,
        setUser,
        meetings,
        setMeetings,
        currentMeeting,
        setCurrentMeeting,
        events,
        setEvents,
        currentEvent,
        setCurrentEvent,
        notifications,
        setNotifications,
        setIsLoading } = useContext(AppContext)
        
        useEffect(() => {
          // if(user && view ==='home'){setView('hub')}
          getData()
          setFView(view)
   
    }, [view])
    let path = `/${view}`
  return (
    <div className="App" id="app">
       <BrowserRouter> 
        <Routes>
          <Route element={<Frame   view={'home'}  />} path="/" exact/>
         <Route element={<Frame  view={'meetings'}  />} path="/meetings"  />
          <Route element={<Frame  view={'meeting'}  />} path="/meeting" />
          <Route element={<Frame  view={'events'}/>} path="/events" exact/>
          <Route element={<Frame  view={'event'} />} path="/event" />
          <Route element={<Frame  view={'vote'}  />} path="/vote" />  
          {/* <Route element={<Frame view={view}  />} path= {path} /> */}
          <Route element={<Frame  view={'signup'} />} path="/signup" />
          <Route element={<Frame  view={'hub'} />}  path="/hub" />
           <Route element={<Frame view={'contacts'}  />} path="/contacts" />
          <Route element={<Frame  view={'create-Meeting'} />} path="/create-Meeting" />
          <Route element={<Frame  view={'vid-conf'} />} path="/vid-conf" />
          <Route element={<Frame  view={'ndaer'} />} path="/ndaer" />
          <Route element={<Frame  view={'test'} />} path="/test" /> 
          
          
          {/* <Route element={<events meetings={meetings} votes={votes}/>} path="/meetings" /> */}
          {/* <Route element={<Meeting meeting={meeting} votes={votes}/>} path="/meeting" /> */}
         {/* <Route element={<Frame view={'error'} />} path="/*" /> */}
        </Routes>
      </BrowserRouter>
      <div style={{position: 'relative', bottom: '0', margin: 'auto',width: '100%', textAlign: 'center'}}>

      © 2023 RexEntropy,LLC
      </div>
    </div>
  );
}

export default App;

     